import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  makeStyles,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { ArrowSync20Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useReindexAll } from "../../hooks/useIndex";
import { ButtonWithLoading } from "../ButtonWithLoading";

const useStyles = makeStyles({
  confirmReindexButton: {
    width: "fit-content",
    gap: "8px",
  },
});

interface ReindexButtonDialogProps {
  entityName: string;
}

export const ReindexButtonDialog = ({
  entityName,
}: ReindexButtonDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showSuccess, setShowSuccess] = useState(false);
  const { mutateAsync: reIndex, isPending } = useReindexAll();

  const submitReindex = async () => {
    await reIndex();
    setShowSuccess(true);
  };

  return (
    <Dialog modalType="alert">
      <DialogTrigger disableButtonEnhancement>
        <Button
          size="large"
          appearance="primary"
          className={classes.confirmReindexButton}
        >
          <ArrowSync20Regular />
          <span>{t("reindex")}</span>
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("reindex", { entity: entityName })}</DialogTitle>
          <DialogContent>
            {t("reindexPrompt", { entity: entityName })}
            {showSuccess && (
              <MessageBar intent="success">
                <MessageBarBody>
                  <MessageBarTitle>{t("reindexStarted")}</MessageBarTitle>
                  {t("reindexRedirectMessage")}
                </MessageBarBody>
              </MessageBar>
            )}
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">{t("cancel")}</Button>
            </DialogTrigger>

            <ButtonWithLoading
              onClick={submitReindex}
              isLoading={isPending}
              text={t("reindex")}
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ReindexButtonDialog;
